<template>
  <FormControl
    :title="title"
    :sub-title="subTitle"
    class="bg-white px-7 py-5 rounded-lg border border-secondary-250">
    <CollaborativeMain
      :id="id"
      :channe-url="channelUrl"
      :current-user="currentUserAccount"
      :hide-content="hideContent"
      :demo="demo"
      :read-only="readOnly"
      :demo-posts="posts"
      :rtl="rtl"
      :is-canvas="isCanvas"
      :background-color="backgroundColor"
      @update-owner-name="handleOwnerNameUpdate"
      @change-background-color="handleBackgroundChange"/>
  </FormControl>
</template>
<script setup lang="ts">
import FormControl from '@/components/utils/FormControl/FormControl.vue';
// import { useVModel } from '@vueuse/core';
// import PVDialog from 'primevue/dialog';
// import EditNote from './EditNote.vue';
import CollaborativeMain from '@amit/collaborative/src/components/CollaborativeMain.vue';
import { PropType } from 'vue';
defineProps({
  id: {
    type: String,
    required: true,
  },
  title: {
    type: String,
    default: '',
  },
  subTitle: {
    type: String,
    default: '',
  },
  channelUrl: {
    type: String,
    default: '',
  },
  currentUserAccount: {
    type: Object as PropType<{ id: string; name: string }>,
    default: () => ({}),
  },
  hideContent: {
    type: Boolean,
    default: false,
  },
  demo: {
    type: Boolean,
    default: false,
  },
  readOnly: {
    type: Boolean,
    default: false,
  },
  posts: {
    type: Array,
    default: () => [],
  },
  isCanvas: {
    type: Boolean,
    default: false,
  },
  rtl: {
    type: Boolean,
    default: false,
  },
  backgroundColor: {
    type: String,
    default: '#d2bea8',
  },
});

const emit = defineEmits(['update-owner-name', 'change-background-color']);

const handleOwnerNameUpdate = ({ name, id }: { name: string; id: string }) => {
  emit('update-owner-name', { name, id });
};

const handleBackgroundChange = (color: string) => {
  emit('change-background-color', color);
};
</script>
<style>
.collaborative-board-block {
  background-size: cover;
  background-repeat: no-repeat;
  border-radius: 8px;
}
</style>
